// Full UAE Free Zone + Mainland data (sourced from official rates)

export const ZONES = [
  {
    id: 'ANCFZ', slug: 'ancfz', name: 'ANCFZ', fullName: 'Ajman NuVentures Centre Free Zone',
    loc: 'Ajman', emirate: 'ajman',
    gov: 4888, govVisa: 10800, svc: 1500, proc: '24–72 hrs',
    acts: '3,500+', maxVis: 3, ownership: 100, corpTax: 0, physical: 'Virtual / Flexi Desk',
    best: ['E-Commerce', 'Software Development', 'Consultancy', 'General Trading'],
    tag: 'MOST AFFORDABLE', officialUrl: 'https://ancfz.ae',
    pros: ['Cheapest free zone in UAE', '24–72 hour processing', 'No minimum capital', 'Virtual desk allowed', '100% foreign ownership'],
    cons: ['Limited activities', 'Ajman address (not Dubai)', 'Lower banking preference', 'Limited warehousing'],
    banking: 'Standard UAE banking. Account opening supported.',
    visa: 'Investor + dependents. Medical + Emirates ID included.',
    renewal: 'Annual renewal. ~15% lower than year 1.',
    highlight: 'Best for solo founders and startups on a budget.',
    color: 'emerald',
  },
  {
    id: 'SPC', slug: 'spc', name: 'SPC Free Zone', fullName: 'Sharjah Publishing City Free Zone',
    loc: 'Sharjah', emirate: 'sharjah',
    gov: 5750, govVisa: 10000, svc: 1500, proc: '3–5 days',
    acts: '2,000+', maxVis: 3, ownership: 100, corpTax: 0, physical: 'Virtual / Flexi Desk',
    best: ['Media', 'Publishing', 'E-Commerce', 'Education', 'E-Books'],
    tag: 'QUICKEST ISSUANCE', officialUrl: 'https://www.spcfz.ae',
    pros: ['2,000+ business activities', 'Media and publishing specialist', 'Sharjah address', 'Flexible packages', 'Low renewal fees'],
    cons: ['Sharjah location (not Dubai)', 'Publishing-focused, less generic', 'Limited industrial activities'],
    banking: 'Standard UAE banking. SPC has banking introduction service.',
    visa: 'Investor visa included in with-visa package.',
    renewal: 'Competitive annual renewal.',
    highlight: 'Best for media, education, content and e-commerce businesses.',
    color: 'bronze',
  },
  {
    id: 'SHAMS', slug: 'shams', name: 'SHAMS', fullName: 'Sharjah Media City Free Zone',
    loc: 'Sharjah', emirate: 'sharjah',
    gov: 8050, govVisa: 13900, svc: 1800, proc: '3–5 days',
    acts: '1,500+', maxVis: 5, ownership: 100, corpTax: 0, physical: 'Virtual / Flexi Desk',
    best: ['Digital Marketing', 'Media Production', 'Creative Agency', 'Advertising', 'Tech Startup'],
    tag: 'MEDIA SPECIALIST', officialUrl: 'https://www.shams.ae',
    pros: ['Media and creative specialist zone', 'Up to 35% multi-year discounts', '5 visa quota', 'Strong banking relationships', 'Government-backed Sharjah zone'],
    cons: ['Higher cost than ANCFZ/SPC', 'Sharjah address', 'Less suitable for trading'],
    banking: 'Premium banking introduction via Sharjah Islamic Bank and others.',
    visa: 'Up to 5 investor visas. Dependent visas available.',
    renewal: 'Multi-year packages available at discount.',
    highlight: 'Best for digital agencies, media companies and creative freelancers.',
    color: 'emerald',
  },
  {
    id: 'RAKEZ', slug: 'rakez', name: 'RAKEZ', fullName: 'Ras Al Khaimah Economic Zone',
    loc: 'Ras Al Khaimah', emirate: 'rak',
    gov: 8500, govVisa: 14800, svc: 1800, proc: '1–2 weeks',
    acts: '1,800+', maxVis: 10, ownership: 100, corpTax: 0, physical: 'Virtual / Flexi Desk / Warehouse',
    best: ['Manufacturing', 'Industrial', 'Logistics', 'General Trading', 'Professional Services'],
    tag: 'INDUSTRIAL POWER', officialUrl: 'https://rakez.com',
    pros: ['Warehouse and industrial facilities', 'Up to 10 visa quota', '1,800+ activities', 'Physical office options', 'Lower land costs'],
    cons: ['RAK address (not Dubai/Sharjah)', 'Longer processing than micro-zones', 'Better for physical business'],
    banking: 'Supported by RAKEZ banking desk.',
    visa: 'Up to 10 investor visas available.',
    renewal: 'Competitive. Industrial packages include renewal discounts.',
    highlight: 'Best for businesses needing physical operations, warehousing or manufacturing.',
    color: 'bronze',
  },
  {
    id: 'MEYDAN', slug: 'meydan', name: 'Meydan FZ', fullName: 'Meydan Free Zone',
    loc: 'Dubai (Nad Al Sheba)', emirate: 'dubai',
    gov: 12500, govVisa: 18500, svc: 2000, proc: '3–5 days',
    acts: '2,500+', maxVis: 10, ownership: 100, corpTax: 0, physical: 'Virtual / Flexi Desk',
    best: ['Consulting', 'Digital Services', 'Finance', 'E-Commerce', 'International Business'],
    tag: 'DIGITAL FIRST', officialUrl: 'https://www.meydanfz.ae',
    pros: ['Dubai address (prestigious)', '2,500+ activities', 'Fast 3–5 day processing', 'Strong banking network', '100% repatriation', 'No corporate tax'],
    cons: ['Higher cost than Sharjah/Ajman zones', 'Less suitable for physical trade', 'Premium pricing'],
    banking: 'Meydan has banking introduction service. Major UAE banks supported.',
    visa: 'Up to 10 visas. Priority processing.',
    renewal: 'Competitive Dubai zone renewal.',
    highlight: 'Best for consultants and digital businesses wanting a premium Dubai address.',
    color: 'emerald',
  },
  {
    id: 'IFZA', slug: 'ifza', name: 'IFZA Dubai', fullName: 'International Free Zone Authority',
    loc: 'Dubai Silicon Oasis', emirate: 'dubai',
    gov: 12900, govVisa: 18500, svc: 2000, proc: '3–5 days',
    acts: '3,000+', maxVis: 15, ownership: 100, corpTax: 0, physical: 'Virtual / Flexi Desk',
    best: ['IT Consulting', 'Software', 'Trading', 'Professional Services', 'International HQ'],
    tag: 'TOP RATED', officialUrl: 'https://ifza.com',
    pros: ['Most flexible: 3,000+ activities', 'Up to 15 visas', 'Excellent banking support', 'Dubai address', 'Multiple licence types in one', 'Strong international reputation'],
    cons: ['Higher cost', 'Renewal fees comparable to year 1', 'Strict documentation review'],
    banking: 'IFZA has dedicated banking introduction. Emirates NBD, Mashreq, Wio and others.',
    visa: 'Up to 15 investor visas. Dependent visas available.',
    renewal: 'Annual renewal standard.',
    highlight: 'Best for international businesses wanting maximum flexibility and Dubai credibility.',
    color: 'bronze',
  },
  {
    id: 'DMCC', slug: 'dmcc', name: 'DMCC', fullName: 'Dubai Multi Commodities Centre',
    loc: 'JLT, Dubai', emirate: 'dubai',
    gov: 17000, govVisa: 25500, svc: 2500, proc: '2–4 weeks',
    acts: '1,600+', maxVis: 20, ownership: 100, corpTax: 0, physical: 'Physical Office Required',
    best: ['Gold Trading', 'Commodities', 'Diamonds', 'Precious Metals', 'International Trade'],
    tag: 'GLOBAL LEADER', officialUrl: 'https://www.dmcc.ae',
    pros: ['9x Free Zone of the Year (FDI)', 'Global commodity hub', 'JLT Dubai address', 'Strong international banking', 'Commodities exchange access', 'Premium reputation'],
    cons: ['Most expensive free zone', 'Physical office required', '4-week processing', 'Heavy documentation'],
    banking: 'Best banking access in UAE. All major international banks.',
    visa: 'Up to 20 visas. Priority government liaison.',
    renewal: 'Premium renewal cost.',
    highlight: 'Best for commodities, gold, precious metals and international trading companies.',
    color: 'emerald',
  },
  {
    id: 'JAFZA', slug: 'jafza', name: 'JAFZA', fullName: 'Jebel Ali Free Zone Authority',
    loc: 'Jebel Ali, Dubai', emirate: 'dubai',
    gov: 16500, govVisa: 22000, svc: 2500, proc: '2–3 weeks',
    acts: '1,200+', maxVis: 15, ownership: 100, corpTax: 0, physical: 'Virtual / Flexi / Warehouse',
    best: ['Logistics', 'Import/Export', 'Distribution', 'Manufacturing', 'Shipping'],
    tag: 'WORLD\'S LARGEST', officialUrl: 'https://www.jafza.ae',
    pros: ['World\'s largest free zone', 'Port access (Jebel Ali Port)', 'Logistics and warehousing', 'Dubai address', 'Established supply chains'],
    cons: ['High cost', 'Long processing', 'Better for physical goods not digital services'],
    banking: 'Standard UAE banking. Port-linked financial services.',
    visa: 'Up to 15 visas.',
    renewal: 'Standard JAFZA renewal.',
    highlight: 'Best for logistics, import/export and businesses needing port access.',
    color: 'bronze',
  },
  {
    id: 'KIZAD', slug: 'kizad', name: 'KIZAD', fullName: 'Khalifa Industrial Zone Abu Dhabi',
    loc: 'Abu Dhabi', emirate: 'abudhabi',
    gov: 11000, govVisa: 16500, svc: 2000, proc: '2–4 weeks',
    acts: '800+', maxVis: 10, ownership: 100, corpTax: 0, physical: 'Physical Space Required',
    best: ['Industrial', 'Manufacturing', 'Abu Dhabi Base', 'Logistics', 'Petrochemicals'],
    tag: 'ABU DHABI HUB', officialUrl: 'https://www.kezadgroup.com',
    pros: ['Abu Dhabi strategic location', 'Industrial and logistics hub', 'Port Khalifa access', 'Government-backed'],
    cons: ['Limited activities', 'Physical space required', 'Long processing time', 'Abu Dhabi cost structure'],
    banking: 'ADCB and Abu Dhabi Islamic Bank supported.',
    visa: 'Up to 10 visas.',
    renewal: 'Standard Abu Dhabi rates.',
    highlight: 'Best for industrial businesses wanting an Abu Dhabi base with port access.',
    color: 'emerald',
  },
  {
    id: 'DAFZA', slug: 'dafza', name: 'DAFZA', fullName: 'Dubai Airport Free Zone Authority',
    loc: 'Dubai Airport', emirate: 'dubai',
    gov: 15000, govVisa: 25000, svc: 2500, proc: '2–3 weeks',
    acts: '1,400+', maxVis: 10, ownership: 100, corpTax: 0, physical: 'Physical Office Required',
    best: ['Aviation', 'Logistics', 'Cargo', 'Tech', 'Pharma'],
    tag: 'AVIATION SPECIALIST', officialUrl: 'https://www.dafz.ae',
    pros: ['Dubai Airport location', 'Aviation and cargo specialist', 'Physical office prestige', 'Strong banking access', 'Government-backed'],
    cons: ['Expensive', 'Physical office required', 'Not suitable for digital-only businesses'],
    banking: 'All major UAE and international banks.',
    visa: 'Up to 10 visas.',
    renewal: 'Premium cost.',
    highlight: 'Best for aviation, cargo, pharmaceutical and logistics businesses needing an airport presence.',
    color: 'bronze',
  },
];

export const MAINLAND_ZONES = [
  {
    id: 'DED_DUBAI', slug: 'dubai-mainland', name: 'Dubai Mainland (DED)', fullName: 'Dubai Department of Economy and Tourism',
    loc: 'Dubai', emirate: 'dubai',
    licenceTypes: [
      { id: 'professional', label: 'Professional Licence', price: 18500, desc: 'For consultants, service providers, professionals' },
      { id: 'commercial', label: 'Commercial Licence', price: 28400, desc: 'For trading, import/export, general commerce' },
      { id: 'industrial', label: 'Industrial Licence', price: 35000, desc: 'For manufacturing, production activities' },
    ],
    proc: '7–14 days', acts: '2,000+', ownership: 100, corpTax: 9, govVisa: 12500,
    pros: ['Full UAE market access', 'Can bid for government contracts', 'Local trading to UAE consumers', 'No activity restrictions for UAE market', 'Can sponsor unlimited visas'],
    cons: ['Local sponsor (51%) required unless regulated profession', 'Higher costs vs free zone', 'Corporate tax 9% applies'],
    highlight: 'Only option for businesses serving UAE consumers directly — restaurants, retail, clinics, construction.',
  },
  {
    id: 'DED_AJM', slug: 'ajman-mainland', name: 'Ajman Mainland (DED)', fullName: 'Ajman Department of Economic Development',
    loc: 'Ajman', emirate: 'ajman',
    licenceTypes: [
      { id: 'professional', label: 'Professional Licence', price: 8500, desc: 'For service providers and professionals' },
      { id: 'commercial', label: 'Commercial Licence', price: 14000, desc: 'For trading and commercial activities' },
      { id: 'industrial', label: 'Industrial Licence', price: 18000, desc: 'For manufacturing and production' },
    ],
    proc: '5–10 days', acts: '1,500+', ownership: 100, corpTax: 9, govVisa: 8000,
    pros: ['Most affordable mainland licence in UAE', 'Same UAE market access as Dubai DED', 'Lower office rent', 'Quick processing'],
    cons: ['Ajman address less prestigious than Dubai', '51% local sponsor required', 'Lower business volume vs Dubai'],
    highlight: 'Best mainland option for cost-conscious businesses needing UAE consumer market access.',
  },
  {
    id: 'DED_SHJ', slug: 'sharjah-mainland', name: 'Sharjah Mainland (DED)', fullName: 'Sharjah Economic Development Department',
    loc: 'Sharjah', emirate: 'sharjah',
    licenceTypes: [
      { id: 'professional', label: 'Professional Licence', price: 11000, desc: 'For service providers and professionals' },
      { id: 'commercial', label: 'Commercial Licence', price: 18000, desc: 'For trading and commercial activities' },
      { id: 'industrial', label: 'Industrial Licence', price: 22000, desc: 'For manufacturing and production' },
    ],
    proc: '5–10 days', acts: '1,500+', ownership: 100, corpTax: 9, govVisa: 9000,
    pros: ['Close to Dubai', 'More affordable than Dubai DED', 'Large industrial areas', 'Strong manufacturing base'],
    cons: ['Less prestigious address', '51% local sponsor required'],
    highlight: 'Best for manufacturing and industrial businesses near Dubai with lower costs.',
  },
];

// Jurisdictions supported by the platform but pending verified live pricing.
// status: ACTIVE | COMING_SOON | UNDER_REVIEW | PRICING_AUDIT | HIDDEN
export const COMING_SOON_JURISDICTIONS = [
  { id: 'SAIF', name: 'SAIF Zone', loc: 'Sharjah', emirate: 'sharjah', status: 'PRICING_AUDIT' },
  { id: 'HFZA', name: 'Hamriyah Free Zone', loc: 'Sharjah', emirate: 'sharjah', status: 'PRICING_AUDIT' },
  { id: 'CREATIVE_CITY', name: 'Creative City', loc: 'Fujairah', emirate: 'fujairah', status: 'COMING_SOON' },
  { id: 'DUBAI_SOUTH', name: 'Dubai South', loc: 'Dubai', emirate: 'dubai', status: 'COMING_SOON' },
  { id: 'DTEC', name: 'DTEC', loc: 'Dubai Silicon Oasis', emirate: 'dubai', status: 'COMING_SOON' },
  { id: 'DWTC', name: 'DWTC Free Zone', loc: 'Dubai', emirate: 'dubai', status: 'COMING_SOON' },
  { id: 'SRTIP', name: 'SRTIP', loc: 'Sharjah', emirate: 'sharjah', status: 'COMING_SOON' },
  { id: 'UAQ_FTZ', name: 'UAQ Free Trade Zone', loc: 'Umm Al Quwain', emirate: 'uaq', status: 'PRICING_AUDIT' },
  { id: 'AJMAN_FZ', name: 'Ajman Free Zone', loc: 'Ajman', emirate: 'ajman', status: 'PRICING_AUDIT' },
  { id: 'DED_AUH', name: 'Abu Dhabi Mainland (DED)', loc: 'Abu Dhabi', emirate: 'abudhabi', status: 'COMING_SOON' },
  { id: 'DED_FUJ', name: 'Fujairah Mainland (DED)', loc: 'Fujairah', emirate: 'fujairah', status: 'COMING_SOON' },
  { id: 'DED_RAK', name: 'RAK Mainland (DED)', loc: 'Ras Al Khaimah', emirate: 'rak', status: 'COMING_SOON' },
  { id: 'DED_UAQ', name: 'UAQ Mainland (DED)', loc: 'Umm Al Quwain', emirate: 'uaq', status: 'COMING_SOON' },
];

export const ADD_ONS = [
  { id: 'extra_visa', label: 'Additional Investor Visa (2yr)', price: 4495, unit: 'per visa', cat: 'visa', icon: 'UserPlus', desc: 'Investor/partner visa. Quota AED 1,600 + visa+EID AED 2,530 + medical AED 365.' },
  { id: 'employee_visa', label: 'Employee Work Visa (2yr)', price: 5665, unit: 'per employee', cat: 'visa', icon: 'BadgeCheck', desc: 'Employee work visa. Quota + employment visa+EID + medical.' },
  { id: 'cos', label: 'Change of Status', price: 700, unit: 'per person', cat: 'visa', icon: 'RefreshCw', desc: 'Required if you are currently in the UAE on a different visa.' },
  { id: 'family_visa', label: 'Dependent / Family Visa', price: 5000, unit: 'per person', cat: 'visa', icon: 'Users', desc: 'Spouse, children or parent visa. Includes medical + EID + change of status.' },
  { id: 'pro_existing', label: 'PRO Services (Existing Company)', price: 3000, unit: 'per year', cat: 'pro', icon: 'ClipboardList', desc: 'Immigration & government paperwork for your existing UAE company.' },
  { id: 'golden_visa', label: 'Golden Visa Consulting', price: 4500, unit: 'per application', cat: 'golden', icon: 'Crown', desc: 'End-to-end Golden Visa (10-year residency) application support.' },
  { id: 'office_flexi', label: 'Flexi Desk Rental', price: 3600, unit: 'per year', cat: 'office', icon: 'Armchair', desc: 'Shared co-working desk with a UAE address. Includes mail handling and meeting rooms.' },
  { id: 'office_private', label: 'Private Office', price: 18000, unit: 'per year', cat: 'office', icon: 'Building2', desc: 'Dedicated private office unit in the freezone.' },
  { id: 'warehouse', label: 'Warehouse Space', price: 25000, unit: 'per year', cat: 'office', icon: 'Warehouse', desc: 'Minimum warehouse unit in freezone or mainland industrial area.' },
  { id: 'corp_tax', label: 'Corporate Tax Registration', price: 850, unit: 'one-time', cat: 'tax', icon: 'FileBarChart', desc: 'UAE Corporate Tax (CT) registration with the FTA.' },
  { id: 'corp_tax_pkg', label: 'CT Starter Package', price: 1200, unit: 'one-time', cat: 'tax', icon: 'FileText', desc: 'CT Registration + bookkeeping (24 txn) + annual P&L + CT Filing.' },
  { id: 'vat_reg', label: 'VAT Registration', price: 1500, unit: 'one-time', cat: 'tax', icon: 'Receipt', desc: 'UAE VAT registration with FTA. Required above AED 375,000 turnover.' },
  { id: 'stamp', label: 'Company Stamp / Seal', price: 250, unit: 'one-time', cat: 'other', icon: 'Stamp', desc: 'Official rubber company stamp. Required for bank account opening.' },
  { id: 'website_bundle', label: 'AI Website Bundle', price: 3500, unit: 'one-time', cat: 'other', icon: 'Globe', desc: 'Professional business website + AI chatbot + WhatsApp integration. FREE above AED 10,000.' },
  { id: 'bank_account', label: 'Bank Account Opening Support', price: 2000, unit: 'one-time', cat: 'banking', icon: 'Landmark', desc: 'Corporate bank account opening assistance with major UAE banks.' },
  { id: 'bookkeeping', label: 'Bookkeeping (up to 50 txn/yr)', price: 850, unit: 'per year', cat: 'tax', icon: 'BookOpen', desc: 'Annual bookkeeping service for up to 50 transactions.' },
  { id: 'mofa_attest', label: 'MOFA Attestation (per document)', price: 650, unit: 'per doc', cat: 'other', icon: 'FileBadge', desc: 'Ministry of Foreign Affairs attestation for individual documents.' },
];

export const COMPANY_INFO = {
  legalName: 'Axiscrest-Global FZE LLC',
  brand: 'SmartSetupUAE.ae',
  license: '262843696888',
  founder: 'Pankaj Choudhary',
  phone: '+971 58 590 3155',
  whatsapp: '+971 58 590 3155',
  whatsappNumber: '971585903155',
  email: 'info@smartsetupuae.ae',
  address: 'CWS-1V-000384, 26th Floor, Amber Gem Tower, Ajman, UAE',
  bank: {
    name: 'Mashreq Bank',
    branch: 'Dubai, UAE',
    swift: 'BOMLAEAD',
    accountName: 'Axiscrest-Global FZE LLC',
    accounts: [
      { currency: 'AED', iban: 'AE58 0330 0000 1234 5678 901', note: 'No conversion charge. Use your order reference as payment note.' },
      { currency: 'USD', iban: 'AE86 0330 0000 1910 1843 402', note: 'Include 5% bank conversion charge in your transfer.' },
      { currency: 'EUR', iban: 'AE56 0330 0000 1910 1843 403', note: 'Include 5% bank conversion charge in your transfer.' },
    ],
    // Backward-compat fallback
    iban: 'AE58 0330 0000 1234 5678 901',
  },
  prebookAmount: 999,
};

export const getZoneBySlug = (slug) => [...ZONES, ...MAINLAND_ZONES].find((z) => z.slug === slug);
